<ng-template
  *ngIf="!referralId; then normalRegister; else registerWithReferralId"
>
</ng-template>

<ng-template #registerWithReferralId>
  <loading class="full" *ngIf="loading">Loading data</loading>
  <ng-container *ngIf="!loading">
    <page-meta
      description="You are invited to join BitOasis! Sign up using this invitation link and earn up to AED 200 with me"
      i18n-description="@@pageMeta.description.referralProgram"
    ></page-meta>
    <app-register-with-referralid
      [referralId]="referralId"
      [referrerName]="referrerName"
      [promotion]="promotion"
      [isExperimentReferral]="isExperimentReferral"
    >
    </app-register-with-referralid>
  </ng-container>
</ng-template>

<ng-template #normalRegister>
  <page-title
    text="Signup | BitOasis"
    i18n-text="@@pageTitle.register"
  ></page-title>
  <site-layout class="narrow push">
    <loading class="full" *ngIf="loading">Loading data</loading>

    <ng-container *ngIf="!loading">
      <ng-container *ngIf="promotion?.promotionEnabled">
        <h2
          class="text-header text-bold text-center text-black mb-2"
          i18n="@@front.register.verifyAndEarn.title"
        >
          Here’s {{ promotion?.reward?.currency }}
          {{ promotion?.reward?.amount }} on us
        </h2>
        <p
          class="text-lg text-center"
          i18n="@@front.register.verifyAndEarn.subtitle"
        >
          Jumpstart your crypto journey today
        </p>
      </ng-container>

      <ng-container *ngIf="!promotion?.promotionEnabled">
        <h2
          class="text-header text-bold text-center text-black mb-2"
          i18n="@@front.home.getStarted.getStartedButton"
        >Get Started</h2>
        <p class="text-lg text-center" i18n="@@front.register.subtitle">
          Create an account
        </p>
      </ng-container>

      <div class="p-3"></div>

      <auth-register></auth-register>
    </ng-container>
  </site-layout>
  <site-footer></site-footer>
</ng-template>
